import styled from 'styled-components';
export const BaseContainer = styled.div.withConfig({ displayName: "vui--BaseContainer", componentId: "vui--jtpszk" }) `box-sizing:border-box;position:relative;margin:0;padding:0;`;
//# sourceMappingURL=BaseContainer.js.map